import { useAuth0 } from "@auth0/auth0-react";
import { IS_NATIVE_APP } from "../../../config/appTarget.js";
import { useFeatureFlag } from "../../../features/featureFlags/useFeatureFlags.js";
import { PAGE_GUTTER_CLASS } from "../../../shared/PageContainer.js";
import ProfileFloater from "../../../shared/Floaters/ProfileFloater.js";
import AdminEntryFloater from "../../../shared/Floaters/AdminEntryFloater.js";
import TopScrim from "../../../shared/Floaters/TopScrim.js";
import MessagesFloater from "./MessagesFloater.js";
import NotificationFloater from "./NotificationFloater.js";

/**
 * Shared fixed-position row for the native landing home: Profile + the Admin
 * shortcut (kennel/super admins only) grouped together on the far left;
 * Messages + Notifications grouped at the far right (in that order, so
 * Notifications stays the rightmost/last-seen button).
 */
const TopFloaters = () => {
  const { isAuthenticated } = useAuth0();
  const adminPipeline = useFeatureFlag("admin_pipeline");

  if (!IS_NATIVE_APP) return null;

  return (
    <>
      <TopScrim />
      <div
        className={`fixed inset-x-0 z-[110] flex items-center justify-between pointer-events-none ${PAGE_GUTTER_CLASS}`}
        style={{ top: "calc(env(safe-area-inset-top) + 12px)" }}
      >
        <div className="flex items-center gap-2">
          <ProfileFloater />
          <AdminEntryFloater />
        </div>
        <div className="flex items-center gap-2">
          {isAuthenticated && adminPipeline && <MessagesFloater />}
          {isAuthenticated && <NotificationFloater />}
        </div>
      </div>
    </>
  );
};

export default TopFloaters;
